import api from './index';

const url = 'log';

export default {
	async create(type, data) {
		return api.post(`${url}/${type}`, data);
	},
};
